import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Avatar, Table, Input, DatePicker, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Carousel, ConfigProvider } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InboxOutlined, EditOutlined, UserOutlined, ExclamationCircleOutlined, CloseCircleOutlined, ToolOutlined } from '@ant-design/icons';
import TeacherModal from './components/TeacherModal';
import Label_language from '../language';
import AdminTeacherModal from './components/AdminTeacherModal';
import PreviewImgModal from './components/Media/PreviewImgModal';
import './css/TableTitle.css'
import NewTable from "./components/NewTable";
const { RangePicker } = DatePicker;
const label_language = Label_language.ems.children
const TeacherList = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale;
    const [language_time, set_language_time] = useState([]);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([undefined, undefined])
    const [is_resign, set_is_resign] = useState(false);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [people, setPeople] = useState(null);
    const [edit, setEdit] = useState(false);
    const [blog_open, set_blog_open] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const { confirm } = Modal;
    const [datas, setDatas] = useState([]);
    const [msg, setMsg] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const [wait_loading, set_wait_loading] = useState(false);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false);
    const [importData, setImportData] = useState([]);
    const navigate = useNavigate();
    const [default_column, set_default_column] = useState([
        {
            title: '照片',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (<>
                <div
                    style={{
                        margin: 0,
                        maxHeight: '64px',
                        width: '64px',
                    }}
                >
                    <Carousel
                        autoplay
                    >
                        {record['file_url'] ? record['file_url'].map((tmp, index) => (<>
                            <div>
                                <Avatar size={64} src={tmp} style={{ cursor: 'pointer' }} onClick={e => handlePreview(tmp)} />
                            </div>
                        </>)) : (<>
                            <div>
                                <Avatar size={64} icon={<UserOutlined />} />
                            </div>
                        </>)}
                    </Carousel>
                </div>
            </>),
        },
        // {
        //     title: '姓名',
        //     key: 'teacher_name',
        //     dataIndex: 'teacher_name',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: '任教系所(單位)',
        //     key: 'teacher_expertise',
        //     dataIndex: 'teacher_expertise',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: '聯絡電話',
        //     key: 'teacher_phone',
        //     dataIndex: 'teacher_phone',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: 'E-mail',
        //     key: 'email',
        //     dataIndex: 'email',
        //     align: 'center',
        // },
        // {
        //     title: '手機',
        //     key: 'teacher_cellphone',
        //     dataIndex: 'teacher_cellphone',
        //     align: 'center',
        // },
        // {
        //     title: '姓名',
        //     key: 'name',
        //     dataIndex: 'name',
        //     align: 'center',
        //     fixed: 'left',
        // },
        {
            title: label_language.basic_data_maintain_management.children.TeacherList.children.name[language],
            key: 'name',
            dataIndex: 'name',
            align: 'center',
            fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.TeacherList.children.school_u_work[language],
            key: 'school_u_work',
            dataIndex: 'school_u_work',
            align: 'center',           
            // fixed: 'left',

        },
        {
            title: label_language.basic_data_maintain_management.children.TeacherList.children.expersite[language],
            key: 'expersite',
            dataIndex: 'expersite',
            align: 'center',
            fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.TeacherList.children.email[language],
            key: 'email',
            dataIndex: 'email',
            align: 'center',
        },
        {
            title:  label_language.basic_data_maintain_management.children.TeacherList.children.phone[language],
            key: 'phone',
            dataIndex: 'phone',
            align: 'center',
        },
        // {
        //     title: '電子信箱',
        //     key: 'email',
        //     dataIndex: 'email',
        //     align: 'center',
        // },
        // {
        //     title: '入職時間',
        //     key: 'employment_time_start',
        //     dataIndex: 'employment_time_start',
        //     align: 'center',
        // },
        // {
        //     title: '離職時間',
        //     key: 'employment_time_end',
        //     dataIndex: 'employment_time_end',
        //     align: 'center',
        // },
        // {
        //     title: '地址',
        //     key: 'address',
        //     dataIndex: 'address',
        //     align: 'center',
        // },
        // {
        //     title: '備註',
        //     key: 'note',
        //     dataIndex: 'note',
        //     align: 'center',
        // },
        {
            title:  label_language.basic_data_maintain_management.children.TeacherList.children.note[language],
            key: 'note',
            dataIndex: 'note',
            align: 'center',
        },
        // {
        //     title: '形象網站',
        //     sorter: false,
        //     align: 'center',
        //     render: (text, record, index) => {
        //         if (record.blog_data.length != 0) {
        //             return (
        //                 <Button type="primary" icon={<EditOutlined />}
        //                     style={{
        //                         display: "inline-flex", alignItems: "center"
        //                     }
        //                     }
        //                     onClick={e => handleOnEdit(record.blog_data[0].blog_id)}
        //                 > 編輯</Button >
        //             )
        //         } else {
        //             return (
        //                 <p>無</p>
        //             )
        //         }
        //     }
        // },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    {/* <button type="button" className="btn btn-link text-success" onClick={e => handleOnShow(record)}>修改</button>
                        <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button> */}
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>編輯</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={() => showMessage(record.teacher_id)}>刪除</Button>
                </>
            )
        },
    ]);

    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnEditRow = (record) => {
        setTitle('修改老師');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record)
    }
    const getData = (param, sort, filter, checklist) => {
        // console.log(checklist);
        set_loading(true);
        set_choose_column(checklist);
        set_custom_filter_value(param?.keyword);
        return axios
            .get('/cramSchool/api/teacher', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    employment_time_start: search_date[0],
                    employment_time_end: search_date[1],
                    is_resign: is_resign,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },
                // paramsSerializer: function (params) {
                //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
                //         if (map_key === 'order') {
                //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
                //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
                //             })
                //         }else if (map_key === 'custom_filter_key') {
                //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
                //         }else{
                //             return `${map_key}=${map_value}`;
                //         }
                //     })
                //     return NewParams.join("&")
                // },
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
                get_picture(response.data.data);
                setPeople(response.data.people);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let teacher_id = value['teacher_id']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (teacher_id == value.teacher_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'teacher',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'teacher'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        reload()
    }, [search_date])
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/teacher`, {
                data: [{ teacher_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();

                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                }
            })

    }
    const handleOnEdit = (value) => {
        setTitle('修改老師');
        setColor('f09a45');
        setEdit(true);
        axios
            .get('/cramSchool/api/blog/teacher', { params: { "blog_id": value } })
            .then((response) => {
                setEditCard(response.data.data[0])
            })
        // setEditCard(value);
        set_blog_open(true)
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'teacher_id': value })
            })
            axios
                .delete(`/cramSchool/api/teacher`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnAddRow = () => {
        setTitle('新增老師');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
    }

    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleEdit = (file_id) => {
        if (editcard.name == undefined || editcard.name == '') {
            messageApi.open({
                type: 'error',
                content: '修改失敗，請填寫姓名',
            });
        } else {
            axios
                .patch(`/cramSchool/api/teacher`, [
                    {
                        ...editcard,
                        file_id,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleSubmit = (file_id) => {
        if (
            // editcard.name == undefined || editcard.name == ''
            editcard.name == undefined || editcard.name == '', editcard.school_u_work == undefined || editcard.school_u_work == '', editcard.expersite == undefined || editcard.expersite == '', editcard.email == undefined || editcard.email == ''

        ) {
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫完整欄位',
            });
        } else {
            axios
                .post(`/cramSchool/api/teacher`, [
                    {
                        ...editcard,
                        file_id,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        reload();
                    }
                })
        }
    }
    useEffect(() => {
        datas.forEach(each_item => {
            if (each_item.teacher_id === editcard.teacher_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [datas])
    const handlePreview = (value) => {
        setImg(value);
        set_modal_img(true);
    }
    const handleExport = () => {
        let language_tmp = [];
        language_time && language_time.map((item) => {
            let value = label_language.basic_data_maintain_management.children.TeacherList.children[`${item}`];
            if (value != undefined) {
                language_tmp.push(JSON.stringify({ [`${item}`]: value }));
            }
        })
        language_tmp.push(
             JSON.stringify({ name: { "zh-tw": "姓名", en: "name" } })
            , JSON.stringify({ school_u_work: { "zh-tw": "任教系所(單位)", en: "school_u_work" } })
            , JSON.stringify({ expersite: { "zh-tw": "聯絡電話", en: "expersite" } })
            , JSON.stringify({ phone: { "zh-tw": "手機", en: "phone" } })
            , JSON.stringify({ email: { "zh-tw": "E-mail", en: "email" } })
            , JSON.stringify({ note: { "zh-tw": "備註", en: "note" } })
            , JSON.stringify({ json_data: { "zh-tw": "json_data", en: "json_data" } })
            , JSON.stringify({ key: { "zh-tw": "key", en: "key" } })
        )
        console.log(language_tmp);
        
        axios
            .get('/cramSchool/api/teacher_excel', {
                responseType: 'blob',
                params: {
                    custom_filter_key: choose_column,
                    custom_filter_value: custom_filter_value,
                    language: language_tmp
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '老師名單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleImportModal = (e) => {
        set_upload_modal(true);
    }
    const handleImport = (e) => {
        set_wait_loading(true);
        const files = e.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', choose_column);
        form_data.append('default_column', JSON.stringify(default_column));
        axios
            .post(`/cramSchool/api/teacher_import/read_sample`, form_data)
            .then((response) => {
                set_upload_modal(false);
                if (JSON.stringify(response.data.duplicate) != '') {
                    let data_tmp = []
                    response.data.duplicate.map((item) => {
                        if (item['emergency_contact'] == undefined) {
                            data_tmp.push({ ...item, emergency_contact: [] })
                        } else {
                            return (
                                data_tmp.push(item)
                            )

                        }
                    })
                    setImportData(data_tmp);
                } else {
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
                set_wait_loading(false)
            })
    }
    const handleDownload = () => {
        axios
            .get('/cramSchool/api/admin/manual/teacher?manual_id=3', {
                responseType: 'blob',
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '教師名單範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleOver = (record) => {
        axios
            .patch(`/cramSchool/api/teacher`, record)
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '覆蓋失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '覆蓋成功',
                    });
                    record && record.map((value) => {
                        setImportData(importData.filter(item => (item.name != value.name) && (item.email != value.email)))
                    })
                    reload();
                }
            })
    }
    useEffect(() => {
        getData();
    }, [is_resign])
    return (
        <>
            {contextHolder}
            <TeacherModal
                open={blog_open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={set_blog_open}
            // handleEdit={handleEdit}
            // handleDelete={handleDelete}
            />
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <AdminTeacherModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <Row justify={'space-between'} style={{ paddingTop: '10px' }}>
                {/* <Col onChange={e => set_is_resign(e.target.checked)}><Checkbox>隱藏離職人員</Checkbox></Col> */}
                {/* <Col>老師總人數：{people}人</Col> */}
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'TeacherList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={'新增老師'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'teacher_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        // searchdate={true}
                        // rangepicker_title={'入職時間'}
                        // handleSearchDate={handleSearchDate}//搜尋日期
                        export={true}
                        import={true}
                        handleImportModal={handleImportModal}
                        language_time={language_time}
                        set_language_time={set_language_time}
                        handleImport={handleImport}
                        handleDownload={handleDownload}
                        set_upload_modal={set_upload_modal}
                        upload_modal={upload_modal}
                        setImportData={setImportData}
                        set_import_modal={set_import_modal}
                        importData={importData}
                        handleOver={handleOver}
                        // handleReserve={handleReserve}
                        import_modal={import_modal}
                        // setImportData={setImportData}
                        wait_loading={wait_loading}
                        // qrcodeNotifyPdf={true}
                        // handleQRcodeNotifyPdf={handleQRcodeNotifyPdf}
                        // qrcodeNotifyLoading={pdfLoading}
                        handleExport={handleExport}
                    ></NewTable>
                </Col>
            </Row>
        </>

    );
};
export default TeacherList;
